import { useRouter } from "next/router";
function useIsPagesRouter() {
  try {
    useRouter();
    return true;
  } catch (error) {
    return false;
  }
}
export {
  useIsPagesRouter
};
//# sourceMappingURL=use-is-pages-router.js.map